<template>
  <div class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-xl shadow-2xl max-w-md w-full p-8 text-center">
      <div class="flex items-center justify-center w-16 h-16 rounded-full bg-brand-50 mx-auto mb-5">
        <svg class="h-8 w-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      </div>
      <h2 class="text-xl font-bold text-gray-900 mb-2">Set Up Your Skills First</h2>
      <p class="text-sm text-gray-500 mb-6">
        Job searches are matched against your skills. Add at least one skill to your profile before creating a search.
      </p>
      <button
        @click="$router.push('/my-skills')"
        class="w-full bg-brand-600 hover:bg-brand-700 text-white font-semibold py-3 rounded-lg text-sm transition-colors"
      >
        Go to My Skills
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { useRouter } from 'vue-router';

export default {
  name: 'SkillsSetupModal',
  setup() {
    const router = useRouter();
    return { router };
  },
};
</script>
